import { Standard } from '@getvim/vim-connect';

export const patientContactInfo: Standard.Entities.PatientContactInfo = {
  homePhoneNumber: '',
  mobilePhoneNumber: '',
  email: '',
};
